import { render, staticRenderFns } from "./widget-pixel-code-instructions.vue?vue&type=template&id=036ec173&scoped=true&"
import script from "./widget-pixel-code-instructions.vue?vue&type=script&lang=js&"
export * from "./widget-pixel-code-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036ec173",
  null
  
)

export default component.exports